import { render, staticRenderFns } from "./Backstage.vue?vue&type=template&id=21734fdb&scoped=true&"
import script from "./Backstage.vue?vue&type=script&lang=js&"
export * from "./Backstage.vue?vue&type=script&lang=js&"
import style0 from "./Backstage.vue?vue&type=style&index=0&id=21734fdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21734fdb",
  null
  
)

export default component.exports